import React, { useEffect, useState } from "react"
import BracketTreeTwoSided from "./component/bracket";
import { getWebTournamentBracket } from "services/tournamentServices";

function CategoryBracket ({
    tournamentId,
    category
}) {
    
    // const [ tournamentType, setTournamentType ] = useState(null)
    const [ seeds, setSeeds ] = useState({
        type: '',
        seeds: []
    })

    useEffect(() => {
        setSeeds({
            type: '',
            seeds: []
        })
        loadBracket()
    }, [category])

    const loadBracket = async () => {
        let { data, error } = await getWebTournamentBracket({
            tournamentId,
            tournamentDetailCategoryId: category
        })
        console.log('here data bracket', data.bracket.tournamentType?.categoryId?.split('_')[1])
        if (data) { setSeeds({
            type: data.bracket.tournamentType?.categoryId?.split('_')[1],
            seeds: data.bracket.seeds
        });}
    }

    return (
        <div>
            <BracketTreeTwoSided seeds={seeds.seeds} type={seeds.type} hasThirdPlace={false} reloadBracket={loadBracket} />
        </div>
    )
}

export default CategoryBracket